import f, { useRef as He, useEffect as Ue } from "react";
import { M as $, F as n, e as O, h as m, m as o, v as We, E as Je, a8 as Z, L as X, C as B, A as I, p as Le, o as j, z as v, a9 as ze } from "./index2.js";
import { a as Ke } from "./index6.js";
var A = $.slower, E = function() {
  var r, i;
  if (typeof window < "u") {
    var l = { setRippleListener: !1, registeredRippleElements: /* @__PURE__ */ new WeakMap() };
    return (i = (r = window).__LEAFYGREEN_UTILS__) !== null && i !== void 0 || (r.__LEAFYGREEN_UTILS__ = { modules: {} }), window.__LEAFYGREEN_UTILS__.modules["@leafygreen-ui/ripple"] = l, window.__LEAFYGREEN_UTILS__.modules["@leafygreen-ui/ripple"];
  }
}();
function Qe(r) {
  E != null && E.registeredRippleElements.has(r.target) && function(i) {
    var l = i.target, d = E == null ? void 0 : E.registeredRippleElements.get(l);
    if (!(!l || !d)) {
      var p = d.backgroundColor, g = l.getBoundingClientRect(), s = document.createElement("span");
      s.className = "lg-ui-ripple", s.style.height = s.style.width = Math.max(g.width, g.height) + "px", l.appendChild(s);
      var h = i.pageY - g.top - s.offsetHeight / 2 - document.body.scrollTop, u = i.pageX - g.left - s.offsetWidth / 2 - document.body.scrollLeft;
      s.style.top = h + "px", s.style.left = u + "px", s.style.background = p, setTimeout(function() {
        s.remove();
      }, 750);
    }
  }(r);
}
function Ve(r, i) {
  if (E) {
    if (E.registeredRippleElements.set(r, i), !E.setRippleListener) {
      document.addEventListener("click", Qe, { passive: !0 });
      var l = document.createElement("style");
      l.innerHTML = Ze, document.head.append(l), E.setRippleListener = !0;
    }
    return function() {
      E.registeredRippleElements.delete(r);
    };
  }
}
var Ze = `
  @-webkit-keyframes lg-ui-ripple {
    from {
      opacity:1;
    }
    to {
      transform: scale(2);
      transition: opacity `.concat(A, `ms;
      opacity: 0;
    }
  }

  @-moz-keyframes lg-ui-ripple {
    from {
      opacity:1;
    }
    to {
      transform: scale(2);
      transition: opacity `).concat(A, `ms;
      opacity: 0;
    }
  }

  @keyframes lg-ui-ripple {
    from {
      opacity:1;
    }
    to {
      transform: scale(2);
      transition: opacity `).concat(A, `ms;
      opacity: 0;
    }
  }

  .lg-ui-ripple {
    position: absolute;
    border-radius: 100%;
    transform: scale(0.2);
    opacity: 0;
    pointer-events: none;
    // Ensures that text is shown above ripple effect
    z-index: -1;
    -webkit-animation: lg-ui-ripple .75s ease-out;
    -moz-animation: lg-ui-ripple .75s ease-out;
    animation: lg-ui-ripple .75s ease-out;
  }

  @media (prefers-reduced-motion: reduce) {
    .lg-ui-ripple {
      animation: none;
      transform: none;
    }
  }
`);
function nn(r, i) {
  var l = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(r);
    i && (d = d.filter(function(p) {
      return Object.getOwnPropertyDescriptor(r, p).enumerable;
    })), l.push.apply(l, d);
  }
  return l;
}
function T(r) {
  for (var i = 1; i < arguments.length; i++) {
    var l = arguments[i] != null ? arguments[i] : {};
    i % 2 ? nn(Object(l), !0).forEach(function(d) {
      e(r, d, l[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(l)) : nn(Object(l)).forEach(function(d) {
      Object.defineProperty(r, d, Object.getOwnPropertyDescriptor(l, d));
    });
  }
  return r;
}
function nr(r) {
  var i = function(l, d) {
    if (typeof l != "object" || !l)
      return l;
    var p = l[Symbol.toPrimitive];
    if (p !== void 0) {
      var g = p.call(l, d || "default");
      if (typeof g != "object")
        return g;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (d === "string" ? String : Number)(l);
  }(r, "string");
  return typeof i == "symbol" ? i : i + "";
}
function e(r, i, l) {
  return (i = nr(i)) in r ? Object.defineProperty(r, i, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : r[i] = l, r;
}
function G() {
  return G = Object.assign ? Object.assign.bind() : function(r) {
    for (var i = 1; i < arguments.length; i++) {
      var l = arguments[i];
      for (var d in l)
        Object.prototype.hasOwnProperty.call(l, d) && (r[d] = l[d]);
    }
    return r;
  }, G.apply(this, arguments);
}
function er(r, i) {
  if (r == null)
    return {};
  var l, d, p = function(s, h) {
    if (s == null)
      return {};
    var u, y, D = {}, P = Object.keys(s);
    for (y = 0; y < P.length; y++)
      u = P[y], h.indexOf(u) >= 0 || (D[u] = s[u]);
    return D;
  }(r, i);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(r);
    for (d = 0; d < g.length; d++)
      l = g[d], i.indexOf(l) >= 0 || Object.prototype.propertyIsEnumerable.call(r, l) && (p[l] = r[l]);
  }
  return p;
}
function a(r, i) {
  return i || (i = r.slice(0)), Object.freeze(Object.defineProperties(r, { raw: { value: Object.freeze(i) } }));
}
var en, rn, on, an, tn, ln, dn, cn, sn, gn, pn, un, bn, hn, fn, mn, yn, kn, xn, wn, vn, On, Dn, En, Pn, Ln, zn, jn, Sn, Gn, Nn, _n, Bn, Mn, In, Tn, Rn, Fn, Cn, qn, An, Xn, Yn, $n, t = { Default: "default", Primary: "primary", PrimaryOutline: "primaryOutline", Danger: "danger", DangerOutline: "dangerOutline", BaseGreen: "baseGreen" }, b = { XSmall: "xsmall", Small: "small", Default: "default", Large: "large" }, M = 0.76, rr = e(e({}, m.Light, e(e(e(e(e(e({}, t.Default, n.gray.light2), t.Primary, n.green.dark1), t.PrimaryOutline, O(M, n.green.base)), t.Danger, n.red.light1), t.DangerOutline, O(M, n.red.base)), t.BaseGreen, n.green.light1)), m.Dark, e(e(e(e(e(e({}, t.Default, n.gray.base), t.Primary, n.green.dark1), t.PrimaryOutline, O(M, n.green.base)), t.Danger, n.red.dark2), t.DangerOutline, O(M, n.red.light1)), t.BaseGreen, n.green.dark1)), or = o(en || (en = a([`
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 5px;
`]))), ar = o(rn || (rn = a([`
  justify-content: space-between;
`]))), je = o(on || (on = a([`
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: relative;
  user-select: none;
  z-index: 0;
  transition: all `, ` ease-in-out;
`])), $.default), Se = e(e(e(e({}, b.XSmall, o(an || (an = a([`
    padding: 0 7px; // 8px - 1px border
    gap: 6px;
  `])))), b.Small, o(tn || (tn = a([`
    padding: 0 11px; // 12px - 1px border
    gap: 6px;
  `])))), b.Default, o(ln || (ln = a([`
    padding: 0 11px; // 12px - 1px border
    gap: 6px;
  `])))), b.Large, o(dn || (dn = a([`
    padding: 0 15px; // 16px - 1px border
    gap: 8px;
  `])))), tr = o(cn || (cn = a([`
  position: absolute;
`]))), lr = o(sn || (sn = a([`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`]))), ir = e(e(e(e({}, b.XSmall, 16), b.Small, 16), b.Default, 16), b.Large, 20), dr = e(e({}, m.Dark, n.gray.light1), m.Light, n.gray.dark1), cr = o(gn || (gn = a([`
  visibility: hidden;
`]))), sr = o(pn || (pn = a([`
  justify-self: right;
`]))), gr = o(un || (un = a([`
  justify-self: left;
`]))), Ge = We("button"), pr = e(e({}, m.Light, e(e(e(e(e(e({}, t.Default, o(bn || (bn = a([`
      color: `, `;
    `])), n.gray.base)), t.Primary, o(hn || (hn = a([`
      color: `, `;
    `])), n.green.light2)), t.PrimaryOutline, o(fn || (fn = a([`
      color: `, `;
    `])), n.green.dark2)), t.Danger, o(mn || (mn = a([`
      color: `, `;
    `])), n.red.light3)), t.DangerOutline, o(yn || (yn = a([`
      color: `, `;
    `])), n.red.light1)), t.BaseGreen, o(kn || (kn = a([`
      color: `, `;
    `])), n.green.dark2))), m.Dark, e(e(e(e(e(e({}, t.Default, o(xn || (xn = a([`
      color: `, `;
    `])), n.gray.light2)), t.Primary, o(wn || (wn = a([`
      color: `, `;
    `])), n.green.light2)), t.PrimaryOutline, o(vn || (vn = a([`
      color: `, `;
    `])), n.green.base)), t.Danger, o(On || (On = a([`
      color: `, `;
    `])), n.red.light2)), t.DangerOutline, o(Dn || (Dn = a([`
      color: `, `;
    `])), n.red.light1)), t.BaseGreen, o(En || (En = a([`
      color: `, `;
    `])), n.green.dark2))), ur = e(e({}, m.Light, e(e(e(e(e(e({}, t.Default, o(Pn || (Pn = a([`
      color: `, `;
    `])), n.black)), t.Primary, o(Ln || (Ln = a([`
      color: `, `;
    `])), n.white)), t.PrimaryOutline, o(zn || (zn = a([`
      color: `, `;
    `])), n.green.dark2)), t.Danger, o(jn || (jn = a([`
      color: `, `;
    `])), n.white)), t.DangerOutline, o(Sn || (Sn = a([`
      color: `, `;
    `])), n.red.base)), t.BaseGreen, o(Gn || (Gn = a([`
      color: `, `;
    `])), n.green.dark3))), m.Dark, e(e(e(e(e(e({}, t.Default, o(Nn || (Nn = a([`
      color: `, `;
    `])), n.white)), t.Primary, o(_n || (_n = a([`
      color: `, `;
    `])), n.white)), t.PrimaryOutline, o(Bn || (Bn = a([`
      color: `, `;
    `])), n.green.base)), t.Danger, o(Mn || (Mn = a([`
      color: `, `;
    `])), n.white)), t.DangerOutline, o(In || (In = a([`
      color: `, `;
    `])), n.red.light1)), t.BaseGreen, o(Tn || (Tn = a([`
      color: `, `;
    `])), n.green.dark3))), br = o(Rn || (Rn = a([`
  .`, ` {
    &:hover,
    &:active {
      color: currentColor;
    }
  }
`])), Ge), hr = e(e(e(e({}, b.XSmall, o(Fn || (Fn = a([`
    height: 14px;
    width: 14px;
  `])))), b.Small, o(Cn || (Cn = a([`
    height: 16px;
    width: 16px;
  `])))), b.Default, o(qn || (qn = a([`
    height: 16px;
    width: 16px;
  `])))), b.Large, o(An || (An = a([`
    height: 20px;
    width: 20px;
  `])))), fr = e(e({}, m.Light, o(Xn || (Xn = a([`
    color: `, `;
  `])), n.gray.base)), m.Dark, o(Yn || (Yn = a([`
    color: `, `;
  `])), n.gray.dark1)), mr = o($n || ($n = a([`
  color: `, `;
`])), n.gray.dark1);
function Y(r) {
  var i = r.glyph, l = r.variant, d = r.size, p = r.darkMode, g = r.disabled, s = r.isIconOnlyButton, h = r.className, u = !s && { "aria-hidden": !0, role: "presentation" }, y = ze(p), D = s ? ur : pr;
  return f.cloneElement(i, T({ className: j(D[y][l], hr[d], e(e(e({}, br, s), fr[y], g), mr, g && s && p), h) }, u));
}
Y.displayName = "ButtonIcon";
var Hn, Un, Wn, Jn, Kn, Qn, Vn, Zn, ne, ee, re, oe, ae, te, le, ie, de, ce, se, ge, pe, ue, be, he, fe, me, ye, ke, xe, we, ve, Oe, De, Ee = function(r) {
  var i, l = r.leftGlyph, d = r.rightGlyph, p = r.className, g = r.children, s = r.variant, h = r.size, u = r.darkMode, y = { variant: s, size: h, darkMode: u, disabled: r.disabled, isIconOnlyButton: (i = (l || d) && !g) !== null && i !== void 0 && i };
  return f.createElement("div", { className: j(je, Se[h], e({}, ar, !!d && u), p) }, l && f.createElement(Y, G({ glyph: l, className: sr }, y)), g, d && f.createElement(Y, G({ glyph: d, className: gr }, y)));
}, yr = function(r) {
  var i, l = r.darkMode, d = r.disabled, p = r.variant, g = r.size, s = r.isLoading, h = r.loadingText, u = r.loadingIndicator, y = r.className, D = Le(l), P = D.darkMode, L = D.theme, S = He(null);
  Ue(function() {
    var N, F = rr[L][p];
    return S.current == null || d || (N = Ve(S.current, { backgroundColor: F })), N;
  }, [S, p, P, d, L]);
  var R = u && f.cloneElement(u, T(T({}, u.props), {}, e({ className: j(e({}, lr, !h), (i = u.props) === null || i === void 0 ? void 0 : i.className), sizeOverride: ir[g], colorOverride: dr[L] }, "data-testid", "lg-button-spinner")));
  return s ? f.createElement(f.Fragment, null, f.createElement("div", { className: j(je, Se[g], e({}, tr, !h)) }, R, h), !h && f.createElement(Ee, G({}, r, { className: j(cr, y) }))) : f.createElement(f.Fragment, null, f.createElement("div", { className: or, ref: S }), f.createElement(Ee, r));
}, kr = "lg-button", c = '&:focus-visible, &[data-focus="true"]', x = '&:hover, &[data-hover="true"]', k = '&:active, &[data-active="true"]', w = function(r) {
  return `
    0 0 0 2px `.concat(r, `, 
    0 0 0 4px `).concat(n.blue.light1, `;
`);
}, xr = o(Hn || (Hn = a([`
  // unset browser default
  appearance: none;
  padding: 0;
  margin: 0;
  background-color: transparent;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: stretch;
  transition: all `, `ms ease-in-out;
  position: relative;
  text-decoration: none;
  cursor: pointer;
  z-index: 0;
  font-family: `, `;
  border-radius: 6px;

  `, ` {
    outline: none;
  }

  `, `,
  &:focus,
  &:hover {
    text-decoration: none;
  }
`])), $.default, Je.default, c, k), wr = e(e({}, m.Light, e(e(e(e(e(e({}, t.Default, o(Un || (Un = a([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      // needed to override any global button styles
      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        box-shadow: 0 0 0 3px `, `;
      }
    `])), n.gray.light3, n.gray.base, n.black, c, n.black, x, k, n.black, n.white, n.gray.light2)), t.Primary, o(Wn || (Wn = a([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: #00593f; // Not quite dark3
        border-color: #00593f; // Not quite dark3
        box-shadow: 0 0 0 3px `, `;
      }
    `])), n.green.dark2, n.green.dark2, n.white, c, n.white, x, k, n.white, n.green.light2)), t.PrimaryOutline, o(Jn || (Jn = a([`
      background-color: transparent;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), n.green.dark2, n.green.dark2, c, n.green.dark2, x, k, n.green.dark2, O(0.96, n.green.base), n.green.light2)), t.Danger, o(Kn || (Kn = a([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: #c82222; // not quite dark1
        border-color: #c82222; // not quite dark1
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), n.red.base, n.red.base, n.white, c, n.white, x, k, n.white, n.red.light3)), t.DangerOutline, o(Qn || (Qn = a([`
      background-color: transparent;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        border-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), n.red.light1, n.red.base, c, n.red.base, x, k, n.red.dark2, O(0.96, n.red.base), n.red.base, n.red.light3)), t.BaseGreen, o(Vn || (Vn = a([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), n.green.base, n.green.dark2, n.green.dark3, c, n.green.dark3, x, k, n.green.dark3, Z(0.96, n.green.base, n.green.dark3), n.green.light2))), m.Dark, e(e(e(e(e(e({}, t.Default, o(Zn || (Zn = a([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        background-color: `, `;
        border-color: `, `;
        color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), n.gray.dark2, n.gray.base, n.white, c, n.white, x, k, n.gray.dark1, n.gray.base, n.white, n.gray.dark2)), t.Primary, o(ne || (ne = a([`
      background-color: `, `;
      border: 1px solid `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: #00593f; // Off palette
        box-shadow: 0 0 0 3px `, `;
      }
    `])), n.green.dark2, n.green.base, n.white, c, n.white, x, k, n.white, n.green.dark3)), t.PrimaryOutline, o(ee || (ee = a([`
      background-color: transparent;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        border-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), n.green.base, n.green.base, c, n.green.base, x, k, n.green.base, O(0.96, n.green.base), n.green.base, n.green.dark3)), t.Danger, o(re || (re = a([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        border-color: `, `;
        color: `, `;
        background-color: #c82222; // Off palette
        box-shadow: 0px 0px 0px 3px `, `; // yes, yellow
      }
    `])), n.red.base, n.red.light1, n.white, c, n.white, x, k, n.red.light1, n.white, n.yellow.dark3)), t.DangerOutline, o(oe || (oe = a([`
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `; // yes, yellow
      }
    `])), n.red.light1, n.red.light1, c, n.red.light1, x, k, n.red.light1, O(0.96, n.red.base), n.yellow.dark3)), t.BaseGreen, o(ae || (ae = a([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        border-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), n.green.base, n.green.dark2, n.green.dark3, c, n.green.dark3, x, k, n.green.dark3, Z(0.96, n.green.base, n.green.light3), n.green.dark2, n.green.dark3))), vr = e(e({}, m.Light, e(e(e(e(e(e({}, t.Default, o(te || (te = a([`
      `, ` {
        background-color: `, `;
        box-shadow: `, `;
      }
    `])), c, n.white, w(n.white))), t.Primary, o(le || (le = a([`
      `, ` {
        color: `, `;
        background-color: #00593f; // Not quite dark3
        box-shadow: `, `;
      }
    `])), c, n.white, w(n.white))), t.PrimaryOutline, o(ie || (ie = a([`
      `, ` {
        background-color: `, `;
        box-shadow: `, `;
      }
    `])), c, O(0.96, n.green.base), w(n.white))), t.Danger, o(de || (de = a([`
      `, ` {
        color: `, `;
        background-color: #c82222; // not quite dark1
        box-shadow: `, `;
      }
    `])), c, n.white, w(n.white))), t.DangerOutline, o(ce || (ce = a([`
      `, ` {
        color: `, `;
        box-shadow: `, `;
      }
    `])), c, n.red.dark2, w(n.white))), t.BaseGreen, o(se || (se = a([`
      `, ` {
        box-shadow: `, `;
      }
    `])), c, w(n.white)))), m.Dark, e(e(e(e(e(e({}, t.Default, o(ge || (ge = a([`
      `, ` {
        background-color: `, `;
        box-shadow: `, `;
      }
    `])), c, n.gray.dark1, w(n.black))), t.Primary, o(pe || (pe = a([`
      `, ` {
        background-color: #00593f; // Off palette
        box-shadow: `, `;
      }
    `])), c, w(n.black))), t.PrimaryOutline, o(ue || (ue = a([`
      `, ` {
        background-color: `, `;
        border-color: `, `;
        box-shadow: `, `;
      }
    `])), c, O(0.96, n.green.base), n.green.base, w(n.black))), t.Danger, o(be || (be = a([`
      `, ` {
        background-color: #c82222; // Off palette
        box-shadow: `, `;
      }
    `])), c, w(n.black))), t.DangerOutline, o(he || (he = a([`
      `, ` {
        background-color: `, `;
        border-color: `, `;
        box-shadow: `, `;
      }
    `])), c, O(0.96, n.red.base), n.red.light1, w(n.black))), t.BaseGreen, o(fe || (fe = a([`
      `, ` {
        background-color: `, `;
        box-shadow: `, `;
      }
    `])), c, n.green.base, w(n.black)))), Or = e(e({}, m.Light, o(me || (me = a([`
    &,
    `, ", ", ` {
      background-color: `, `;
      border-color: `, `;
      color: `, `;
      box-shadow: none;
      cursor: not-allowed;
    }

    `, ` {
      color: `, `;
      box-shadow: `, `;
    }
  `])), x, k, n.gray.light2, n.gray.light1, n.gray.base, c, n.gray.base, w(n.white))), m.Dark, o(ye || (ye = a([`
    &,
    `, ", ", ` {
      background-color: `, `;
      border-color: `, `;
      color: `, `;
      box-shadow: none;
      cursor: not-allowed;
    }

    `, ` {
      color: `, `;
      box-shadow: `, `;
    }
  `])), x, k, n.gray.dark3, n.gray.dark2, n.gray.dark1, c, n.gray.dark1, w(n.black))), Dr = e(e(e(e({}, b.XSmall, o(ke || (ke = a([`
    height: 22px;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 1em;
    font-weight: `, `;
    letter-spacing: 0.4px;
  `])), X.bold)), b.Small, o(xe || (xe = a([`
    height: 28px;
  `])))), b.Default, o(we || (we = a([`
    height: 36px;
  `])))), b.Large, o(ve || (ve = a([`
    height: 48px;
    font-size: 18px;
    line-height: 24px;
  `])))), Er = e(e({}, I.Body1, o(Oe || (Oe = a([`
    font-size: `, `px;
    line-height: `, `px;
    font-weight: `, `;
  `])), B.body1.fontSize, B.body1.lineHeight, X.medium)), I.Body2, o(De || (De = a([`
    font-size: `, `px;
    line-height: `, `px;
    // Pixel pushing for optical alignment purposes
    transform: translateY(1px);
    font-weight: `, `;
  `])), B.body2.fontSize, B.body2.lineHeight, X.medium)), Pr = ["variant", "size", "darkMode", "data-lgid", "baseFontSize", "disabled", "onClick", "leftGlyph", "rightGlyph", "children", "className", "as", "type", "isLoading", "loadingIndicator", "loadingText"], Pe = f.forwardRef(function(r, i) {
  var l = r.variant, d = l === void 0 ? t.Default : l, p = r.size, g = p === void 0 ? b.Default : p, s = r.darkMode, h = r["data-lgid"], u = h === void 0 ? kr : h, y = r.baseFontSize, D = y === void 0 ? I.Body1 : y, P = r.disabled, L = P !== void 0 && P, S = r.onClick, R = r.leftGlyph, N = r.rightGlyph, F = r.children, Ne = r.className, H = r.as, _e = r.type, U = r.isLoading, W = U !== void 0 && U, Be = r.loadingIndicator, Me = r.loadingText, C = er(r, Pr), J = Le(s).darkMode, K = !(!C.href && H !== "a" || L), _ = !(L || W), Ie = function(z) {
    var Q = z.variant, Fe = z.size, Ce = z.darkMode, qe = z.baseFontSize, V = z.disabled, q = ze(Ce), Ae = wr[q][Q], Xe = vr[q][Q], Ye = Dr[Fe], $e = Er[qe];
    return j(xr, Ae, $e, Ye, e({}, Xe, !V), e({}, Or[q], V));
  }({ variant: d, size: g, darkMode: J, baseFontSize: D, disabled: !_ }), Te = T({ "data-lgid": u, type: K ? void 0 : _e || "button", className: j(Ge, Ie, Ne), ref: i, as: H || (K ? "a" : "button"), "aria-disabled": !_, onClick: _ ? S : function(z) {
    return z.preventDefault();
  }, href: _ ? C.href : void 0 }, C), Re = { rightGlyph: N, leftGlyph: R, darkMode: J, disabled: L, variant: d, size: g, isLoading: W, loadingIndicator: Be, loadingText: Me };
  return f.createElement(Ke, Te, f.createElement(yr, Re, F));
});
Pe.displayName = "Button", Pe.propTypes = { variant: v.oneOf(Object.values(t)), baseFontSize: v.oneOf(Object.values(I)), size: v.oneOf(Object.values(b)), darkMode: v.bool, disabled: v.bool, leftGlyph: v.element, rightGlyph: v.element, href: v.string, isLoading: v.bool, loadingText: v.string, loadingIndicator: v.element };
export {
  Pe as I,
  b as k,
  t as x
};
